import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=facb69fc&"
import script from "./ContactBlock.vue?vue&type=script&lang=coffee&"
export * from "./ContactBlock.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports